module.exports = __webpack_public_path__ + "static/media/GL.a748be4f.svg";